export default __webpack_public_path__ + "static/media/internal-external-trainings.c4901f07.svg";